import FirebaseHandlerBase from "../firebase_handler_base";
import {ISubscriptionParams} from "../firebase_const";
import {SYSTEM_EVENTS} from "../../../../events/events";
import Event from '../../../../utils/event';
import {INetPositionGameTypeData, INPReceivedInfo} from "./netposition_handler.interfaces";




export default class NetPositionHandler extends FirebaseHandlerBase{
  static class: string = "NetPositionHandler";

  protected getSubscriptionParams(): ISubscriptionParams {
    return {
      eventName: 'casinoGamesNetPosition',
      successCallback: this._updateNetPosition
    };
  }

  protected getFeatureName(): string {
    return "NetPosition";
  }

  protected getFeatureLabel(): string {
    return "NetPosition";
  }

  protected getFallbackServiceName(): string{
    return null;
  }

  private _updateNetPosition = (collectionData: INPReceivedInfo[]) => {
    if(collectionData.length !== 0){
      const updatedGameTypes: INetPositionGameTypeData[] = collectionData.map(t => t.data);

      Event.fire(SYSTEM_EVENTS.SESSION_EVENT_NET_POSITION_UPDATE, updatedGameTypes);

      this.logger.debug('Firebase got net positions message. Parsed data: ' + JSON.stringify(updatedGameTypes));

      //Filter elastic Net position updates only for vip users, avoiding too much reporting
      const accountData = this.serviceFactory.userService().getAccountData();
      if (accountData && accountData.IsVip) {
          this.serviceFactory.firebaseElasticService().sendMessageUpdate(this.getFeatureLabel(), JSON.stringify(updatedGameTypes));
      }
    }
  }
}